import { trigger, state, style, transition, animate, query, group } from '@angular/animations';

export const OverlayPaneAnimation = trigger('overlayPaneAnimation',[
    state('hide', style({opacity: 0, transform: 'translateY(10%)'})),
    state('show',style({opacity: 1, transform: 'translateY(0%)'})),
    transition('hide => show', [
        //query('.body', style({height: 0, padding: 0})),
        group([
           // query('.body', animate('400ms ease-out', style({height: '*', padding: '1em'}))),
            animate('600ms cubic-bezier(0.25, 0.8, 0.25, 1)'),
        ])
    ]),
    transition('show => hide', [
      animate('200ms  cubic-bezier(0.25, 0.8, 0.25, 1)')
    ])
]);